import angular from 'angular';
import * as _ from 'lodash';
import * as actions from '../../store/actions';

angular.module('webTools').service('File', [
  '$q',
  '$http',
  '$ngRedux',
  function($q, $http, $ngRedux) {
    return {
      download: async function (selectedItems, operationType, packageCallback, isProject, isProjectSync, projectId) {

        const isWebView = window.chrome?.webview;

        const createdownloadpackage = folder => {
          var parameters = {
            localPath: folder,
            operationType: operationType,
            machineName: localStorage.getItem('localMachineName'),
            objects: selectedItems,
            zipMultipleFiles: !isWebView,
            isProject: isProject,
            isProjectSync: isProjectSync,
            projectId: projectId
          };

          return $http.post('/api/downloadpackage/execute', parameters);
        };

        const showErrors = (errorList) => {
          if (errorList.length > 0) {

            let errorString = '<div style="margin-bottom: 5px"><strong>The following errors occurred during checkout:</strong></div>';

            errorList.forEach((ff) => {
              errorString += `<div style="padding: 5px 0">${ff.errorMessage}</div>`;
            })

            $ngRedux.dispatch(actions.showModal('ERROR', [], { content: errorString }));
          }
        }

        if (!Array.isArray(selectedItems)) {
          selectedItems = _.toArray(selectedItems);
        }

        if (window.chrome?.webview) {
          let folder = null;

          const isCheckout = operationType === 'checkout';

          if (isCheckout) {
            folder = JSON.parse(localStorage.getItem('localPaths')).workingDirectory;
          }

          createdownloadpackage(folder).then(res => {

            const { fileList, errorList } = res.data;

            showErrors(errorList);

            const data = fileList.map(obj => ({
              ...obj,
              useWorkingFolder: isCheckout,
              launch: isCheckout,
              notification: !isCheckout
            }));

            // _.forEach(data, (downloadItem) => {
            //   window.postMessage({ action: 'download-queue', payload: downloadItem });
            // })

            window.chrome?.webview.postMessage({ action: 'download', payload: data });
            
            if (typeof packageCallback === 'function') {
              packageCallback();
            }

          });
        } else {
          createdownloadpackage().then(res => {

            const { fileList, errorList } = res.data;

            showErrors(errorList);

            if (res.data.fileList.length > 0) {
              const fileInfo = {
                fileId: fileList[0].objectId,
                packageId: fileList[0].packageId,
                path: '/api/download/get'
              };

              $ngRedux.dispatch(actions.initiateDownload(fileInfo));

              if (typeof packageCallback === 'function') {
                packageCallback();
              }
            }
          });
        }
      },
      undoCheckout: (selectedItems, isProject, packageCallback) => {

        $http.post('/api/undocheckout/undo', { objects: selectedItems, isProject }).then((response) => {

          if (window.chrome?.webview) {
            response.data.forEach(repositoryPath => {
              window.chrome?.webview.postMessage({ action: 'undocheckout', payload: [{ fullLocalFilePath: repositoryPath }]});
            })
          }

          if (typeof packageCallback === 'function') {
            packageCallback();
          }
        });

      },
      upload: function(files, localPath, operationId, operationType) {
        var defer = $q.defer();

        if (!Array.isArray(files)) {
          files = _.toArray(files);
        }

        var parameters = {
          files: files,
          localPath: localPath,
          operationId: operationId,
          operationType: operationType
        };

        $http.post('/api/files', parameters).then(function(response) {
          let data = response.data;
          defer.resolve(data);
        });

        return defer.promise;
      },
      projectDownload: function(objects) {
        var parameters = {
          objects,
          isProject: false
        };

        var request = {
          method: 'POST',
          url: '/api/download/createdownloadpackage',
          data: JSON.stringify(parameters)
        };

        return $http(request);
      },
      getDetails: function(fileId) {
        var promises = {
          deferred: $q.defer(),
          canceler: $q.defer()
        };
        $http
          .get('/api/filedetails/getdetails/?id=' + fileId, {
            timeout: promises.canceler.promise
          })
          .then(function(response) {
            let data = response.data;
            promises.deferred.resolve(data);
          });

        return promises;
      },
      rename: function(objectId, objectType, newFileName) {
        var defer = $q.defer();

        $http
          .post('/api/documents/rename/', {
            IsFolder: false,
            ObjectID: objectId,
            ObjectType: objectType,
            NewName: newFileName
          })
          .then(function(response) {
            let data = response.data;
            defer.resolve(data);
          });

        return defer.promise;
      },
      isInProject: function(fileId) {
        var defer = $q.defer();

        $http
          .post('/api/documents/fileinproject/', { fileId })
          .then(function(response) {
            let data = response.data;
            defer.resolve(data);
          });

        return defer.promise;
      },
      getWorkingPaths: function (fileIds) {
        var defer = $q.defer();

        $http
          .post('/api/files/getworkingpaths', fileIds)
          .then(function (response) {
            let data = response.data;
            defer.resolve(data);
          });

        return defer.promise;
      }
    };
  }
]);
